import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdCall, MdEmail, MdLocationPin, MdSearch, MdWhatsapp } from "react-icons/md";
import { AiFillWechat } from "react-icons/ai";

export default function ContactUsContent(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}


	

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6
								className="main-section-title"
							>
								Contact Us
							</h6>
						</div>

						

						<div className="col-md-12 rounded p-3 border">
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									
									window.open('mailto:info@bostonujiqueservicesltd.com', '_blank')
									
								}}
								className="font-semi-bold text-dark"
							>
								<MdEmail size={32}/> info@bostonuniqueservicesltd.com
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open('tel:+255686042070', '_blank')
								}}
								className="font-semi-bold text-dark"
							>
								<MdCall size={32}/> +255655626638/ +255763626638
							</h6>

							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/255763626638", "_blank");
							
								}}
								className="font-semi-bold text-dark"
							>
								<MdWhatsapp size={32}/> Click to chat with us on WhatsApp
							</h6>

							
							<h6
								style={{
									fontSize: "14px",
									padding: "10px",
									cursor: "pointer",
								}}
								onClick={() => {
									window.open("https://wa.me/255763626638", "_blank");
							
								}}
								className="font-semi-bold text-dark"
							>
								<MdLocationPin size={32}/> Mwenge near TRA, Dar Es Salaam
							</h6>
							
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}